import us from '../../defines';
import { setIconState } from '../../toolbar';
import { eRASTERPARMS } from './constants';
import {translate} from 'shared/services/I18nService';
import { renderSettings } from '../../render-settings';
const $t = translate.scope('uScope.extensions.raster-scan');

export default function RasterPanel (uScope) {
  // todo: when a setting is changed it must be changed for ALL images

  var self = this;
  var jPanel;
  var jProgressBar;
  let tbOpenIcon;
  var isDialogVisible = false;

  // ............................................ close() public
  // This function closes the raster panel;
  this.close = function () {
    jPanel.dialog('close');
  };
  // ............................................ start() public
  // This function clicks the raster panel start button which
  //    sets the panel state and calls the rasterScan object's start()
  this.start = function () {
    $('.' + us.RPSTART).click();
  };
  // ............................................ pause() public
  // This function clicks the raster panel pause button which
  //    sets the panel state and calls the rasterScan object's stop()
  this.pause = function () {
    $('.' + us.RPPAUSE).click();
  };
  // ............................................ configure_()
  var configure_ = function () {
    if (uScope.isThisImageValid()) {
      var thisImg = uScope.getThisImage();
      if (thisImg && thisImg.rasterScan) {
        var rasterObj = thisImg.rasterScan;
        var rasterMag = rasterObj.parmAction('get', eRASTERPARMS.MAG);
        var rasterMode = rasterObj.parmAction('get', eRASTERPARMS.MODE);
        var info = $t('mode-scan-at-mag', {
          mode: (rasterMode === 'Manual' ? $t('manual') : $t('automatic')),
          mag: rasterMag
        });
        $('#' + us.idRPTEXT).text(info);
        var instr = (rasterMode == 'Manual') ? $t('spacebar-steps-view')
          : $t('spacebar-pause-resume');
        $('#' + us.idRPINSTR).text(instr);

        // set the checked state of the sequence style
        var segValue = rasterObj.parmAction('get', eRASTERPARMS.SEQUENCESTYLE);
        var btnSel = $('.' + us.clsSEQUENCESTYLE)[segValue];
        btnSel.children[0].checked = true; // check current raster scan segmentation type
        $(btnSel).addClass(us.clsRSSTYLESEL); // add selected state to this button
      }
    }
  };
  // ............................................ show() local
  var show = function (show) {
    if (show == true) {
      jPanel.dialog('open');
      configure_();
    } else {
      jPanel.dialog('close');
    }
  };
  // ............................................ isOpen() public
  this.isOpen = function () {
    return !!((jPanel && jPanel.hasClass('ui-dialog-content') && jPanel.dialog('isOpen')));
  };
  // ............................................ settingsAdv_() local
  var settingsAdv_ = function () {
    var m;
    if ($(us.idHashROOT).find('#' + us.idRASTERSETADV).length > 0) return; // already open, then return
    if (uScope.isThisImageValid() == false) return false;
    var thisImg = uScope.getThisImage(); // there must be a valid image
    var rasterObj = thisImg.rasterScan;

    var jSettingsAdv = $('<div/>', {
      'id': us.idRASTERSETADV,
      'class': us.clsPANEL + ' ' + us.clsPANELCLICKCLOSE,
      'title': $t('advanced-raster-settings')
    });

    // ................................................. // raster view overlap selection
    jSettingsAdv.append($('<div/>', {'class': 'tooldivider', css: {'visibility': 'hidden'}}));

    var strSelect = `<select id="${us.idRPOVERLAP}" class="${us.clsSELECTBOX}" style="width: 110px" title="${$t('view-overlap-title')}">`;
    for (m = 10; m < 100; m += 10) {
      strSelect += '<option  value="' + m + '">&nbsp;' + m + '%</option>';
    }
    strSelect += '</select>';
    var jOverlap = $(strSelect);

    jOverlap.change(function () {
      var value = parseInt(jOverlap[0][jOverlap[0].selectedIndex].value, 10);
      rasterObj.parmAction('set', eRASTERPARMS.OVERLAPPCT, value);
    });
    jOverlap.set = function () {
      var overlapSelected = rasterObj.parmAction('get', eRASTERPARMS.OVERLAPPCT);
      for (var o = 0; o < jOverlap[0].length; o++) {
        if (jOverlap[0][o].value == overlapSelected) {
          jOverlap[0].selectedIndex = o;
          break;
        }
      }
    };
    jOverlap.set();
    jSettingsAdv.append(jOverlap);
    jSettingsAdv.append($(`<span>&nbsp;${$t('view-overlap')}</span>`));

    // ................................................. // raster pattern selection
    jSettingsAdv.append($('<div/>', {'class': 'tooldivider', css: {'visibility': 'hidden'}}));
    strSelect = `<select id="${us.idRPPATTERN}" class="${us.clsSELECTBOX}" style="width: 110px" title="${$t('raster-pattern-title')}">`;
    var list = rasterObj.parmAction('get', eRASTERPARMS.PATTERNLIST);
    for (m = 0; m < list.length; m++) { strSelect += '<option  value="' + list[m].name + '">&nbsp;' + $t('pattern-list', {pattern: $t(list[m].name.toLowerCase())}) + '</option>'; }
    strSelect += '</select>';
    var jPattern = $(strSelect);

    jPattern.change(function () {
      var idx = jPattern[0].selectedIndex;
      var value = jPattern[0][idx].value;
      rasterObj.parmAction('set', eRASTERPARMS.PATTERNNAME, value);
    });
    jPattern.set = function () {
      var patternSelected = rasterObj.parmAction('get', eRASTERPARMS.PATTERNNAME);
      for (var o = 0; o < jPattern[0].length; o++) {
        if (jPattern[0][o].value == patternSelected) {
          jPattern[0].selectedIndex = o;
          break;
        }
      }
    };
    jPattern.set();
    jSettingsAdv.append(jPattern);
    jSettingsAdv.append($(`<span>&nbsp;${$t('raster-pattern')}</span>`));

    // ................................................. // raster threshold selection
    jSettingsAdv.append($('<div/>', {'class': 'tooldivider', css: {'visibility': 'hidden'}}));
    strSelect = `<select id="${us.idRPTHRESHOLD}" class="${us.clsSELECTBOX}" style="width: 110px" title="${$t('tissue-threshold-title')}">`;
    if (thisImg.getCaptureType() == us.eAICCaptureType.aic_i_FL) {
      for (m = 5; m < 50; m += 5) {
        strSelect += '<option  value="' + m + '">&nbsp;' + m + '</option>';
      }
    } else {
      for (m = 170; m < 230; m += 10) {
        strSelect += '<option  value="' + m + '">&nbsp;' + m + '</option>';
      }
    }
    strSelect += '</select>';
    var jPixelThresh = $(strSelect);

    jPixelThresh.change(function () {
      var idx = jPixelThresh[0].selectedIndex;
      var value = parseInt(jPixelThresh[0][idx].value, 10);
      rasterObj.parmAction('set', eRASTERPARMS.PIXELTHRESH, value);
    });
    jPixelThresh.set = function () {
      var pixelThresh = rasterObj.parmAction('get', eRASTERPARMS.PIXELTHRESH);
      for (var o = 0; o < jPixelThresh[0].length; o++) {
        if (jPixelThresh[0][o].value == pixelThresh) {
          jPixelThresh[0].selectedIndex = o;
          break;
        }
      }
    };
    jPixelThresh.set();
    jSettingsAdv.append(jPixelThresh);
    jSettingsAdv.append($(`<span>&nbsp;${$t('tissue-threshold')}</span>`));

    // ................................................. // default button
    jSettingsAdv.append($('<div/>', {'class': 'tooldivider', css: {'visibility': 'hidden'}}));
    jSettingsAdv.append($('<button/>', {
      'id': us.idRPSETTINGSDEF,
      'class': us.clsRPBUTTON + ' ' + us.clsSETBUTTON,
      'text': $t('default'),
      'title': $t('reset-settings'),
      click: function () {
        rasterObj.parmAction('default', eRASTERPARMS.OVERLAPPCT);
        jOverlap.set();
        rasterObj.parmAction('default', eRASTERPARMS.PATTERNNAME);
        jPattern.set();
        rasterObj.parmAction('default', eRASTERPARMS.PIXELTHRESH);
        jPixelThresh.set();
      }
    }));

    // ................................................. // position and open the raster advanced settings panel
    var offsetPos = $('#' + us.idRASTERSETTINGS).offset();
    if (offsetPos == null || offsetPos == undefined) offsetPos = {'left': 0, 'top': 0};
    jSettingsAdv.dialog({
      autoOpen: true,
      left: offsetPos.left,
      top: offsetPos.top,
      closeOnEscape: true,
      resizable: false,
      width: 260,
      height: 230,
      dialogClass: 'uscope-dialog dialogMover',
      closeText: $t('close'),
      appendTo: us.idHashROOT,
      open: function () {
        // Because the raster panels open sequential dialogs the normal CSS/DOM stacking mechanism doesn't
        // work. Call `moveToTop` to ensure these dialogs don't appear behind each-other. Since this one is triggered
        // by a click on it's parent dialog, `moveToTop` is called internally on the parent, making it appear on
        // top of this, its child. Deferring execution allows the window to account for this.
        window.setTimeout(function () {
          jSettingsAdv.dialog('moveToTop');
        });
        isDialogVisible = true;
      },
      close: function (event, ui) { // remove this panel and the raster settings panel
        $(this).remove();
        $('#' + us.idRASTERSETTINGS).remove();
        isDialogVisible = false;
      }
    });
  };

  // ............................................ settings_() local
  var settings_ = function () {
    if ($(us.idHashROOT).find('#' + us.idRASTERSETTINGS).length > 0) return; // already open, then return
    if (uScope.isThisImageValid() == false) return false;
    var thisImg = uScope.getThisImage(); // there must be a valid image
    var rasterObj = thisImg.rasterScan;

    var jSettings = $('<div/>', {
      'id': us.idRASTERSETTINGS,
      'class': us.clsPANEL + ' ' + us.clsPANELCLICKCLOSE,
      'title': $t('raster-settings')
    });

    // ................................................. // raster mode selection
    var jMode = $('<input type="checkbox" class="ui-corner-all"  id="' + us.idRASTERMODE + '" /><label for="' + us.idRASTERMODE + '">&nbsp;' + $t('auto-scan') + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>');
    jMode.change(function () {
      rasterObj.parmAction('toggle', eRASTERPARMS.MODE);
      configure_();
    });
    jMode.attr('title', $t('manual-automatic-raster-scanning'));
    jMode.set = function () {
      jMode.prop('checked', (rasterObj.parmAction('get', eRASTERPARMS.MODE) == 'Automatic'));
    };
    jMode.set(); // initialize check state
    jSettings.append(jMode);

    // ................................................. // raster magnification selection
    var magList = renderSettings.magnificationList;
    rasterObj.parmAction('get', eRASTERPARMS.MAG);

    var strSelect = '<select id="' + us.idRASTERMAG + '" class="' + us.clsSELECTBOX + '>';
    for (var m = 0, len = magList.length; m < len; m++) {
      var mag = magList[m];
      if (mag > 1 && mag < thisImg.getMaximumMag()) {
        strSelect += '<option  value="' + mag + '">&nbsp;' + mag + 'X</option>';
      }
    }
    strSelect += '</select>';
    var jMagnification = $(strSelect);
    jMagnification.attr('title', $t('select-raster-scan-magnification')); // add tooltip

    jMagnification.change(function () {
      var value = parseInt(jMagnification[0][jMagnification[0].selectedIndex].value, 10);
      rasterObj.parmAction('set', eRASTERPARMS.MAG, value);
      configure_();
    });
    jMagnification.set = function () {
      var magSelected = rasterObj.parmAction('get', eRASTERPARMS.MAG);
      for (var o = 0; o < jMagnification[0].length; o++) {
        if (jMagnification[0][o].value == magSelected) {
          jMagnification[0].selectedIndex = o;
          break;
        }
      }
    };
    jMagnification.set();
    jSettings.append(jMagnification);
    jSettings.append($(`<span>${$t('magnification')}&nbsp;</span>`));

    // ................................................. // default button
    jSettings.append($('<div/>', {'class': 'tooldivider', css: {'visibility': 'hidden'}}));
    jSettings.append($('<button/>', {
      id: us.idRPSETTINGSDEF,
      class: us.clsRPBUTTON + ' ' + us.clsSETBUTTON,
      text: $t('default'),
      title: $t('reset-settings'),
      click: function () {
        rasterObj.parmAction('default', eRASTERPARMS.MODE);
        jMode.set();
        rasterObj.parmAction('default', eRASTERPARMS.MAG);
        jMagnification.set();
        configure_();
      }
    }));

    // ................................................. // advanced settings button
    jSettings.append($('<a/>', {
      id: us.RPSETTINGSADV,
      class: us.clsRPBUTTON + ' ' + us.RPSETTINGSADV,
      title: $t('advanced-settings'),
      click: function () {
        settingsAdv_();
      }
    }));

    // ................................................. // position and open the RASTER settings panel
    var offsetPos = $('#' + us.idRASTERPANEL).offset();
    if (offsetPos == null || offsetPos == undefined) offsetPos = {'left': 0, 'top': 0};
    jSettings.dialog({
      autoOpen: true,
      left: offsetPos.left,
      top: offsetPos.top,
      closeOnEscape: true,
      resizable: false,
      width: 260,
      height: 140,
      dialogClass: 'uscope-dialog dialogMover',
      closeText: $t('close'),
      open: function () {
        // Because the raster panels open sequential dialogs the normal CSS/DOM stacking mechanism doesn't
        // work. Call `moveToTop` to ensure these dialogs don't appear behind each-other. Since this one is triggered
        // by a click on it's parent dialog, `moveToTop` is called internally on the parent, making it appear on
        // top of this, its child. Deferring execution allows the window to account for this.
        window.setTimeout(function () {
          jSettings.dialog('moveToTop');
        });
      },
      close: function (event, ui) {
        $(this).remove(); // remove this panel and change the icon
        setIconState($('#' + us.RPSETTINGS), us.RPSETTINGS, 'enabled');
      }
    });

    // ................................................. // append this modeless dialog to uscope's root div - the dialog is the parent to the panel created
    jSettings.parent().appendTo(us.idHashROOT);
  };

  // ............................................ init_() local
  //    init_ - This function creates and intializes the RASTER panel
  var init_ = function () {
    uScope.events.on('uscope:resize', self.position);

    if (jPanel != undefined) {
      jPanel.remove();
    }

    jPanel = $(`<div id=${us.idRASTERPANEL} class=${us.clsPANEL} title=${$t('raster')}></div>`);

    jPanel.append($('<a/>', {
      'id': us.RPSETTINGS,
      'class': us.clsRPBUTTON + ' ' + us.RPSETTINGS,
      'title': $t('change-settings')
    }));
    jPanel.append($('<div/>', {'id': us.idRPTEXT, 'text': $t('raster-scan', {space: ''})}));
    jPanel.append($('<div/>', {'id': us.idRPINSTR, 'text': ''}));

    jPanel.append($('<a/>', {
      'id': us.RPBACKUP,
      'class': us.clsRPBUTTON + ' ' + us.RPBACKUP,
      'title': $t('reset-progress')
    }));
    jPanel.append($('<a/>', {
      'id': us.RPSLOW,
      'class': us.clsRPBUTTON + ' ' + us.RPSLOW + '-d',
      'title': $t('slow-down')
    }));
    jPanel.append($('<a/>', {
      'id': us.RPSTART,
      'class': us.clsRPBUTTON + ' ' + us.RPSTART,
      'title': $t('start-raster-scan')
    }));
    jPanel.append($('<a/>', {
      'id': us.RPFAST,
      'class': us.clsRPBUTTON + ' ' + us.RPFAST + '-d',
      'title': $t('speed-up')
    }));

    jPanel.append($('<div/>', {'class': 'tooldivider', css: {'visibility': 'hidden'}}));
    var jBarDiv = $('<div/>', {'id': us.RPRASTERBAR, 'title': $t('raster-progress')});
    jBarDiv.append($('<div/>'));
    jPanel.append(jBarDiv);

    jPanel.dialog({
      autoOpen: false,
      closeOnEscape: true,
      resizable: false,
      width: 240,
      height: 'auto',
      minHeight: 0,
      dialogClass: 'uscope-dialog dialogMover',
      closeText: $t('close'),
      appendTo: us.idHashROOT,
      open: function (event, ui) {
        if (uScope.isThisImageValid() == true) {
          var thisImg = uScope.getThisImage();
          setIconState(tbOpenIcon, us.TBRASTEROPEN, 'active');
          if (thisImg.rasterScan != undefined) {
            thisImg.rasterScan.onPanelOpen();
          }
        }
      },
      close: function (event, ui) {
        setIconState(tbOpenIcon, us.TBRASTEROPEN, 'enabled');
        if (uScope.isThisImageValid() == true) {
          var thisImg = uScope.getThisImage();
          if (thisImg.rasterScan != undefined) {
            thisImg.rasterScan.resetHeatMapState();
            if (thisImg.rasterScan.parmAction('get', eRASTERPARMS.MODE) == 'Manual') {
              self.pause(); // closing panel in manual mode forces a raster pause
            }
          }
        }
      },
      focus: function (event, ui) { // requires a click // doing this for debug when open dlg at b4 image open
        configure_();
      }
    });

    jProgressBar = $('#' + us.RPRASTERBAR).find('div');

    // add a radio buttonset to select the sequence style - buttonset doesn't work until after the dialog is associated with the panel
    var str = '<div id=' + us.idRSSTYLEDIV + '>' +
      '<label id="us_piecescanL" title="' + $t('scan-each-tissue') + '" class ="' + us.clsSEQUENCESTYLE + '"><input type="radio" id="us_piecescan" name="radio" Value =' + us.eSEQUENCESTYLES.BYTISSUEPIECES + '></label>' +
      '<label id="us_tissuescanL" title="' + $t('scan-all-tissue') + '" class ="' + us.clsSEQUENCESTYLE + '"><input type="radio" id="us_tissuescan" name="radio" Value =' + us.eSEQUENCESTYLES.ALLTISSUE + '></label>' +
      '<label id="us_slidescanL" title="' + $t('scan-whole-slide') + '"  class ="' + us.clsSEQUENCESTYLE + '"><input type="radio" id="us_slidescan"  name="radio"  Value =' + us.eSEQUENCESTYLES.WHOLESLIDE + '></label>' +
      '</div>';
    jPanel.append($(str));
    $('#' + us.idRSSTYLEDIV).buttonset(); // convert the radio button look to a buttonset

    self.position(); // position the panel
    bindEvents_(); // add event handlers
    configure_(); // initialize for the current image
  };
  // ............................................ bindEvents_() local
  // bindEvents_ - This function adds the raster scan panel event handlers.
  //
  //    Note that an exception is made here and the namespace is not an image's namespace.

  var bindEvents_ = function () {
    var namespace = '.raster';

    tbOpenIcon = $('<a/>', {
      'id': us.TBRASTEROPEN,
      'class': us.clsTBBUTTON + ' ' + us.TBRASTEROPEN + '-e',
      'title': $t('toolbar-button-hover-text')
    });
    uScope.topToolbar.addButton(tbOpenIcon);

    tbOpenIcon.on('click', function () {
      show(!isDialogVisible);
      return false;
    });

    $(us.idHashROOT).on('click' + namespace, '.' + us.RPSTART, function (e) {
      if (uScope.isThisImageValid()) {
        var thisImg = uScope.getThisImage();
        if (thisImg && thisImg.rasterScan) {
          $('#' + us.RPSTART).addClass(us.RPPAUSE).removeClass(us.RPSTART); // change start btn to pause
          $('#' + us.RPSTART).attr('title', $t('stop-pause-scan')); // and update pause tooltop

          if (thisImg.rasterScan.parmAction('get', eRASTERPARMS.MODE) == 'Automatic') { // if raster scan mode is automatic,
            $('#' + us.RPSLOW).addClass(us.RPSLOW).removeClass(us.RPSLOW + '-d'); // enable faster/slower btns
            $('#' + us.RPFAST).addClass(us.RPFAST).removeClass(us.RPFAST + '-d');
            $('#' + us.RPBACKUP).addClass(us.RPBACKUP + '-d').removeClass(us.RPBACKUP); // disable backup during raster
          } else {
            $('#' + us.RPBACKUP).addClass(us.RPBACKUP).removeClass(us.RPBACKUP + '-d'); // enable backup during raster mode manual
          }
          // todo: how to get the above icons to change right away??? preload images? (tissue segmentation delay is an issue)
          thisImg.rasterScan.start();
        }
      }
    });
    $(us.idHashROOT).on('click' + namespace, '.' + us.RPPAUSE, function (e) {
      if (uScope.isThisImageValid()) {
        var thisImg = uScope.getThisImage();

        $('#' + us.RPSTART).addClass(us.RPSTART).removeClass(us.RPPAUSE); // change pause btn to start
        $('#' + us.RPSTART).attr('title', $t('start-resume-scan')); // and update start tooltop
        $('#' + us.RPSLOW).addClass(us.RPSLOW + '-d').removeClass(us.RPSLOW); // disable faster/slower btns
        $('#' + us.RPFAST).addClass(us.RPFAST + '-d').removeClass(us.RPFAST);
        $('#' + us.RPBACKUP).addClass(us.RPBACKUP).removeClass(us.RPBACKUP + '-d'); // enable backup during pause

        thisImg.rasterScan.stop();
      }
    });
    $(us.idHashROOT).on('click' + namespace, '.' + us.RPBACKUP, function (e) {
      if (uScope.isThisImageValid()) {
        var thisImg = uScope.getThisImage();
        thisImg.rasterScan.progressReset('backup'); // todo: it might be better if restart could be signalled differenly and this fn local
        $('#' + us.RPSTART).attr('title', $t('start-raster-scan'));
        jProgressBar.width('0%');
      }
    });
    $(us.idHashROOT).on('click' + namespace, '.' + us.RPSLOW, function (e) {
      if (uScope.isThisImageValid()) {
        var thisImg = uScope.getThisImage();
        thisImg.rasterScan.parmAction('set', eRASTERPARMS.SPEEDFACTOR, 'slower');
      }
    });
    $(us.idHashROOT).on('click' + namespace, '.' + us.RPFAST, function (e) {
      if (uScope.isThisImageValid()) {
        var thisImg = uScope.getThisImage();
        thisImg.rasterScan.parmAction('set', eRASTERPARMS.SPEEDFACTOR, 'faster');
      }
    });
    $(us.idHashROOT).on(us.evRASTERPROGRESS + namespace, function (e, parms) {
      jProgressBar.width(parms.progressPct + '%');
    });
    $(us.idHashROOT).on('click' + namespace, '.' + us.clsSEQUENCESTYLE, function (e) {
      var input = this.children[0]; // 'this' is the label that encloses the input
      if (input.checked == true) return; // if already checked, do nothing ( getting 2 clicks for every 1)
      $(input).checked = true; // because of how the images are on the radio btns, do this myself

      $('.' + us.clsSEQUENCESTYLE).removeClass(us.clsRSSTYLESEL); // remove selected state from other button
      $(this).addClass(us.clsRSSTYLESEL); // add selected state to this button

      var value = $(input).val(); // the selected raster sequence style

      var thisImg = uScope.getThisImage();
      if (thisImg && thisImg.rasterScan) { // inform the raster object of the selected sequence style
        thisImg.rasterScan.parmAction('set', eRASTERPARMS.SEQUENCESTYLE, +value);
      }
    });
    $(us.idHashROOT).on('click' + namespace, '.' + us.RPSETTINGS, function (e) {
      setIconState($('#' + us.RPSETTINGS), us.RPSETTINGS, 'active');
      settings_();
    });

    uScope.events.on('uscope:image:close', () => {
      self.pause();
    });
  };
  // ............................................ position() public
  //    position - This function positions the raster panel to the right of the zoom control.
  //        Note that it assume the zoom control has room to its right ... instead cOverLayout should be updated to handle this.
  let lastPosition_;
  self.position = () => {
    if (!self.isOpen()) {
      return;
    }
    var panelPos;
    var thisImg = uScope.getThisImage();
    var jVpDiv = (thisImg) ? thisImg.vpDivGet('outer') : undefined;
    var jZoomControl = (jVpDiv) ? jVpDiv.find('.' + us.clsDIVZOOMCTL) : undefined;
    if (!uScope.isThisImageValid() || !jZoomControl) {
      var rootPos = $(us.idHashROOT).offset();
      panelPos = [rootPos.left, Math.floor(rootPos.top + $(us.idHashROOT).height() / 3)];
    } else {
      var offsetPos = jZoomControl.offset(); // returns 0,0 when zoomcontrol is hidden, e.g. rasterscan mode
      var zoomWidth = jZoomControl.width();
      if (!offsetPos) {
        offsetPos = {'left': 0, 'top': 0};
      }
      if (offsetPos.left === 0 && offsetPos.top === 0 && !!lastPosition_) {
        panelPos = lastPosition_;
      } else {
        panelPos = [offsetPos.left + zoomWidth + us.kOVERLAY_ELEMENT_SPACE, offsetPos.top];
      }
    }
    lastPosition_ = panelPos;
    $('#' + us.idRASTERPANEL).dialog({left: panelPos[0], top: panelPos[1]});
  };

  init_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/raster-scan/raster-panel.js